import React from 'react';
import { reviews } from '../../data';
import SafeIcon from '../../common/SafeIcon';
import { motion } from 'framer-motion';

const Reviews = () => {
  return (
    <section className="py-24 bg-frost-ice/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">Sweet Words</h2>
          <p className="text-gray-600">Don't just take our word for it. See what our customers are saying.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <motion.div 
              key={review.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white p-8 rounded-3xl shadow-sm border border-frost-ice relative"
            >
              <div className="text-frost-ice-dark absolute top-6 right-6 opacity-20">
                <SafeIcon icon="FiMessageSquare" className="text-6xl" />
              </div>
              <div className="flex gap-1 text-yellow-400 mb-6">
                {[...Array(5)].map((_, i) => (
                  <SafeIcon 
                    key={i} 
                    icon="FiStar" 
                    className={i < review.rating ? "fill-current" : "text-gray-300"} 
                  />
                ))}
              </div>
              <p className="text-gray-700 mb-8 italic relative z-10 leading-relaxed">
                "{review.text}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-frost-berry/10 rounded-full flex items-center justify-center text-frost-berry font-bold font-serif">
                  {review.name.charAt(0)}
                </div>
                <div>
                  <h4 className="font-bold text-sm">{review.name}</h4>
                  <p className="text-xs text-gray-500">{review.location}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;